/**
 * Builds the same POST body as the Orders list (`getAllOrders` → GET_SELLER_ORDER).
 * Use for bulk label/zip and any feature that must respect the same filters as the table.
 */
export type BuildOrderListPayloadInput = {
    skip: number;
    limit: number;
    filterPayLoad: {
      filterArrOne?: any[];
      filterArrTwo?: any[];
    };
    startDate: any;
    endDate: any;
    searchedText: string;
    subStatus: string;
    /** Tab value, e.g. LOST_AND_DAMAGE */
    currentStatus: string;
    sortByOrderId?: "" | "asc" | "desc";
  };

  export function buildOrderListApiPayload(input: BuildOrderListPayloadInput) {
    const {
      skip,
      limit,
      filterPayLoad,
      startDate,
      endDate,
      searchedText,
      subStatus,
      currentStatus,
      sortByOrderId,
    } = input;

    let sort: any = { _id: -1 };
    if (sortByOrderId === "asc") {
      sort = { orderId: 1 };
    } else if (sortByOrderId === "desc") {
      sort = { orderId: -1 };
    }

    let payload: any = {
      skip,
      limit,
      sort,
      currentStatus,
    };
  
    let firstFilterData: any = [];
    let secondFilterData: any = [];
  
    const f1 = filterPayLoad?.filterArrOne ?? [];
    const f2 = filterPayLoad?.filterArrTwo ?? [];
  
    if (f1.length > 0 || f2.length > 0) {
      const newFilterArrOne = f1.filter(
        (obj: any) => !Object.keys(obj).includes("createdAt")
      );
  
      firstFilterData = newFilterArrOne;
      secondFilterData = f2;
    }
  
    if (startDate && endDate) {
      let startEpoch = null;
      let lastendEpoch = null;
  
      if (startDate instanceof Date && endDate instanceof Date) {
        const sd = new Date(startDate.getTime());
        const ed = new Date(endDate.getTime());
        sd.setHours(0, 0, 0, 0);
        startEpoch = sd.getTime();
  
        ed.setHours(23, 59, 59, 999);
        const endEpoch = ed.getTime();
  
        lastendEpoch = endEpoch;
      }
  
      firstFilterData.unshift(
        {
          createdAt: {
            $gte: startEpoch,
          },
        },
        {
          createdAt: {
            $lte: lastendEpoch,
          },
        }
      );
    }
  
    if (firstFilterData.length > 0 || secondFilterData.length > 0) {
      payload.filterArrOne = firstFilterData;
      payload.filterArrTwo = secondFilterData;
    }
  
    if (searchedText?.length > 0) {
      payload.id = searchedText;
    }
    if (subStatus != "" && currentStatus == "DRAFT") {
      payload.subStatus = subStatus;
    }
  
    const apiPayload = {
      ...payload,
      currentStatus:
        currentStatus === "LOST_AND_DAMAGE" ? "LOST/DAMAGE" : currentStatus,
    };
  
    return { payload, apiPayload };
  }